var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.6709 175C58.2483 175 24.6709 141.423 24.6709 100C24.6709 58.5774 58.2483 25 99.6709 25C141.094 25 174.671 58.5774 174.671 100C174.671 141.423 141.094 175 99.6709 175Z",
    fill: "url(#paint0_linear_26801_268)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.622 56.1016H42.7783C40.4812 56.1016 38.6768 57.906 38.6768 60.2031V129.93C38.6768 136.738 44.1726 142.234 50.9814 142.234H96.0986H100.2H104.302H149.419C156.228 142.234 161.724 136.738 161.724 129.93V60.2031C161.724 57.906 159.919 56.1016 157.622 56.1016Z",
    fill: "url(#paint1_linear_26801_268)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166.099 52H34.3018C32.0347 52 30.2002 53.8345 30.2002 56.1016C30.2002 58.3686 32.0347 60.2031 34.3018 60.2031H166.099C168.366 60.2031 170.2 58.3686 170.2 56.1016C170.2 53.8345 168.366 52 166.099 52Z",
    fill: "url(#paint2_linear_26801_268)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.2 167.391C98.7236 167.391 97.4109 167.636 96.0986 168.129V142.234H104.302V168.129C102.99 167.636 101.677 167.391 100.2 167.391Z",
    fill: "url(#paint3_linear_26801_268)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6924 101.219H91.9971C94.2641 101.219 96.0986 103.053 96.0986 105.32C96.0986 116.628 86.9021 125.828 75.5908 125.828C64.2795 125.828 55.083 116.628 55.083 105.32C55.083 94.0129 64.2795 84.8125 75.5908 84.8125C77.8579 84.8125 79.6924 86.647 79.6924 88.9141V101.219Z",
    fill: "url(#paint4_linear_26801_268)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8955 72.5078C87.8955 70.2407 89.73 68.4062 91.9971 68.4062C103.308 68.4062 112.505 77.6066 112.505 88.9141C112.505 91.1811 110.67 93.0156 108.403 93.0156H91.9971C89.73 93.0156 87.8955 91.1811 87.8955 88.9141V72.5078Z",
    fill: "url(#paint5_linear_26801_268)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.81 76.6094H141.216C143.483 76.6094 145.317 78.4439 145.317 80.7109C145.317 82.978 143.483 84.8125 141.216 84.8125H124.81C122.543 84.8125 120.708 82.978 120.708 80.7109C120.708 78.4439 122.543 76.6094 124.81 76.6094Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.81 93.0156H141.216C143.483 93.0156 145.317 94.8501 145.317 97.1172C145.317 99.3843 143.483 101.219 141.216 101.219H124.81C122.543 101.219 120.708 99.3843 120.708 97.1172C120.708 94.8501 122.543 93.0156 124.81 93.0156Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.81 109.422H141.216C143.483 109.422 145.317 111.256 145.317 113.523C145.317 115.791 143.483 117.625 141.216 117.625H124.81C122.543 117.625 120.708 115.791 120.708 113.523C120.708 111.256 122.543 109.422 124.81 109.422Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.2 180C113.2 187.18 107.38 193 100.2 193C93.0205 193 87.2002 187.18 87.2002 180C87.2002 172.82 93.0205 167 100.2 167C107.38 167 113.2 172.82 113.2 180ZM96.3002 180C96.3002 182.154 98.0463 183.9 100.2 183.9C102.354 183.9 104.1 182.154 104.1 180C104.1 177.846 102.354 176.1 100.2 176.1C98.0463 176.1 96.3002 177.846 96.3002 180Z",
    fill: "url(#paint6_linear_26801_268)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_268",
    x1: 24.6709,
    y1: 36.7188,
    x2: 167.639,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_268",
    x1: 100.2,
    y1: 56.1016,
    x2: 100.2,
    y2: 142.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_268",
    x1: 53.2002,
    y1: 54.5,
    x2: 61.3312,
    y2: 82.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECF1FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_268",
    x1: 98.7646,
    y1: 142.234,
    x2: 90.969,
    y2: 164.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECF1FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_268",
    x1: 61.3635,
    y1: 68.4063,
    x2: 127.766,
    y2: 109.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26801_268",
    x1: 61.3635,
    y1: 68.4063,
    x2: 127.766,
    y2: 109.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26801_268",
    x1: 87.2002,
    y1: 169.031,
    x2: 111.981,
    y2: 191.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/Presentation.139b2490cb79e0d8c9870c52c4553726.svg";
export { ForwardRef as ReactComponent };